import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/california_conservation_module_flood_plain_layer': {
    fld_zone: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'fld_zone',
            type: PaintColorTypes.CATEGORICAL,
            stops: [
              {
                value: 'AH',
                label: 'AH - Areas With A 1% Annual Chance Of Shallow Flooding',
                color: '#cfecf7',
              },
              {
                value: 'AO',
                label: 'AO - River Or Stream Flood Hazard Areas',
                color: '#a0d9ef',
              },
              {
                value: 'A',
                label: 'A - Areas With A 1% Annual Chance Of Flooding',
                color: '#62c1e5',
              },
              {
                value: 'AE',
                label: 'AE - Base Floodplain Elevation',
                color: '#20a7db',
              },
              {
                value: 'A99',
                label:
                  'A99 - Areas With A 1% Annual Chance - Protected By Federal Flood Control System',
                color: '#1c96c5',
              },
              {
                value: 'V',
                label:
                  'V - Coastal Areas With >= 1% Chance Of Flooding And Additional Storm Wave Hazard',
                color: '#5aa492',
              },
              {
                value: 'VE',
                label:
                  'VE - Coastal Areas With >= 1% Chance Of Flooding And Additional Storm Wave Hazard',
                color: '#2e6b61',
              },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
